module.exports = __webpack_public_path__ + "static/media/logo.f87b2565.png";